var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61057 5.78484V4.35027C9.61057 3.4625 9.25791 2.61109 8.63016 1.98334C8.00241 1.35559 7.151 1.00293 6.26324 1.00293C5.37547 1.00293 4.52406 1.35559 3.89631 1.98334C3.26856 2.61109 2.9159 3.4625 2.9159 4.35027V5.78484C2.9159 7.36287 1.48132 7.74543 1.48132 8.65399C1.48132 9.46691 3.34627 10.0886 6.26324 10.0886C9.1802 10.0886 11.0451 9.46691 11.0451 8.65399C11.0451 7.74543 9.61057 7.36287 9.61057 5.78484Z",
    stroke: "#1D3948",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26318 11.045C5.77973 11.045 5.32545 11.0287 4.89795 10.9972C4.98909 11.2879 5.17066 11.5419 5.41622 11.7223C5.66178 11.9027 5.9585 11.9999 6.26318 11.9999C6.56787 11.9999 6.86459 11.9027 7.11015 11.7223C7.35571 11.5419 7.53728 11.2879 7.62842 10.9972C7.20092 11.0287 6.74664 11.045 6.26318 11.045Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOutlined);
export default __webpack_public_path__ + "static/media/bell-outlined.ee5ced96628446efa28f1057196d1847.svg";
export { ForwardRef as ReactComponent };